import { create } from "apisauce";
import Cookies from "js-cookie";
import { getNowDateIso, getNextDateIso } from "../utils/utils";

const customerkey = process.env.REACT_APP_CUSTOMER_KEY;
const customersecret = process.env.REACT_APP_CUSTOMER_SECRET;

export const baseurlwc = process.env.REACT_APP_BASE_URL_WC;
export const credentials = `consumer_key=${customerkey}&consumer_secret=${customersecret}`;
export const baseurl = process.env.REACT_APP_BASE_URL_API;

const ActualMonth = getNowDateIso();
const NextMonth = getNextDateIso();

const api = create({
  baseURL: baseurlwc,
  headers: { Accept: "application/vnd.github.v3+json" },
});

/* ----------------------------------------------------- */
/* Helper genérico para paginación                       */
/* ----------------------------------------------------- */
const fetchAllPaginated = async (endpoint) => {
  const perPage = 100;
  let page = 1;
  let allItems = [];

  try {
    const hasQuery = endpoint.includes("?");

    while (true) {
      const response = await api.get(
        `${endpoint}${hasQuery ? "&" : "?"}per_page=${perPage}&page=${page}`
      );

      const items = response.data || [];
      allItems = allItems.concat(items);

      if (items.length < perPage) break;

      page++;
    }

    return { data: allItems };
  } catch (error) {
    console.error("Error in paginated request:", error);
    throw new Error(`Paginated fetch failed: ${error.message}`);
  }
};


/* ----------------------------------------------------- */
/* ORDERS                                                */
/* ----------------------------------------------------- */

export const getOrderById = (orderId) =>
  api.get(`/orders/${orderId}?${credentials}`);

export const getCustomerOrders = () =>
  api.get(`/orders?status=enviado&${credentials}`);

export const getAllOrdersWhosales = (numpage = 1) =>
  api.get(
    `/orders?status=sendwholesaler&per_page=100&page=${numpage}&before=${NextMonth}&after=${ActualMonth}&${credentials}`
  );

export const getReportsTotal = () =>
  api.get(`/reports/orders/totals?${credentials}`);

export const reportSalesToday = () => api.get(`/reports/sales?${credentials}`);

export const getCustomerOrdersEnviados = () =>
  api.get(`/orders?status=processing&${credentials}`);

export const getCustomerOrderssendwholesaler = () =>
  api.get(`/orders?status=sendwholesaler&per_page=100&${credentials}`);

/* ----------------------------------------------------- */
/* PRODUCTS - Categoría ARIS / MARCAS / ATRIBUTOS            */
/* ----------------------------------------------------- */

/* 🔥 TODAS LAS Categoría ARIS (con paginado real) */
export const GetAllCategorys = () =>
  fetchAllPaginated(`/products/categories?${credentials}`);

/* 🔥 TODAS LAS MARCAS (con paginado real) */
export const GetAllBrands = () =>
  fetchAllPaginated(`/products/brands?${credentials}`);

/* 🔥 TODOS LOS ATRIBUTOS (con paginado real) */
export const GetAllAttributes = () =>
  fetchAllPaginated(`/products/attributes?${credentials}`);

/* 🔥 TODOS LOS TÉRMINOS DE UN ATRIBUTO (con paginado real) */
export const GetAllTermsAttributes = (id) =>
  fetchAllPaginated(`/products/attributes/${id}/terms?${credentials}`);

/* ----------------------------------------------------- */
/* PRODUCT CRUD                                          */
/* ----------------------------------------------------- */

export const AddProductWC = (data) =>
  api.post(`/products?${credentials}`, { data });

export const AddAttributes = (data) =>
  api.put(`/products/${Cookies.get("productid")}/?${credentials}`, data);
